import { RefObject, useEffect, useRef } from 'react'

import ResizeObserver from 'resize-observer-polyfill'

import { neloLogger } from '@web/libs/utils'

type Prop = {
  callback: (entry: ResizeObserverEntry) => void
  /** DOM전체의 Resize Observe 여부 */
  isRoot?: boolean
}

type ReturnType = {
  targetRef: RefObject<HTMLDivElement>
}

const useResizeObserver = ({ callback, isRoot }: Prop): ReturnType => {
  const targetRef = useRef<HTMLDivElement>(null)

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    try {
      const observer = new ResizeObserver(([entry]) => callback(entry))

      if (isRoot) {
        observer.observe(document.body)
      } else if (targetRef.current) {
        observer.observe(targetRef.current)
      }

      return () => observer.disconnect()
    } catch (error) {
      neloLogger('warn', 'ResizeObserver Not Found', { error })
    }
  }, [callback, targetRef, isRoot])

  return { targetRef }
}

export default useResizeObserver
